export async function callGetData (http, url, params) {
  return http.get(url, params).then(result => {
    return result
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

export async function callPostData (http, url, data, params) {
  return http.post(url, data, params).then(result => {
    return result
  }).catch(error => {
    return { type: 'error', message: error }
  })
}

export async function callPutData (http, url, params) {

}

export async function callPatchData (http, url, params) {

}

export async function callDeleteData (http, url, params) {

}
